module.exports = __webpack_public_path__ + "opensource-forum-fe/static/img/error.ca9375ec.png";